<template>
  <div class="case-path-navigator d-flex">
    <div class="case-path-navigator__icon-wrapper">
      <font-awesome-icon
        @click="getBackHome"
        :icon="['fas', 'home']"
        class="case-path-navigator__icon"
      />
    </div>

    <img
      v-if="routeHistory.length || routeType === 'Template'"
      src="~assets/breadcrumb.png"
      class="case-path-navigator__separator"
    />
    <div v-if="routeType === 'Template'" class="d-flex align-items-center">
      <div class="case-path-navigator__item" @click="goToTemplates">
        {{ $t('knowledge.templates.description') }}
      </div>

      <img
        v-if="routeHistory.length"
        src="~assets/breadcrumb.png"
        class="case-path-navigator__separator"
      />
    </div>
    <span
      v-for="(route, idx) in dynamicRoutes"
      :key="route.id"
      class="d-flex align-items-center"
    >
      <el-tooltip
        v-if="route.id === -1"
        placement="bottom"
        class="group-tooltip"
        effect="light"
      >
        <div
          slot="content"
          v-for="(route, slicedIdx) in slicedRoutes"
          :key="route.id"
        >
          <p
            @click="sendUpdateCasePath(route, slicedIdx + 2)"
            class="mb-0 case-path-navigator__sliced-item"
          >
            {{ route.label }}
          </p>
        </div>
        <p
          @click="sendUpdateCasePath(route, idx)"
          :class="[
            'mb-0',
            'case-path-navigator__item',
            'd-flex',
            dynamicRoutes.length === idx + 1
              ? 'case-path-navigator__item--last-step'
              : '',
          ]"
        >
          {{ route.label }}
        </p>
      </el-tooltip>
      <p
        v-else
        @click="sendUpdateCasePath(route, idx)"
        :class="[
          'mb-0',
          'case-path-navigator__item',
          'd-flex',
          dynamicRoutes.length === idx + 1
            ? 'case-path-navigator__item--last-step'
            : '',
        ]"
      >
        {{ route.label }}
      </p>
      <img
        v-if="dynamicRoutes.length > idx + 1"
        src="~assets/breadcrumb.png"
        class="case-path-navigator__separator"
      />
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'case-path-navigator',
  props: {
    routeHistory: {
      type: Array,
      required: true,
    },
    routeType: String,
  },
  methods: {
    sendUpdateCasePath(route, idx) {
      if (route.type || route.id === -1) return;
      this.updateCasePath(this.routeHistory.slice(0, idx + 1));

      this.goToTranslatedEntity({
        entityId: route.id,
        entityType: 'Case',
      });
    },
    getBackHome() {
      this.goToTranslatedEntity({ entityType: 'Knowledge' });
    },
    goToTemplates() {
      this.$router.push('/knowledge/templates');
    },
    ...mapActions('kbStore', ['updateCasePath']),
    ...mapActions('knowledgeModule', ['goToTranslatedEntity']),
  },
  computed: {
    breadcrumbCharLength() {
      return this.routeHistory.reduce(
        (acc, route) => acc + route.label.length,
        0,
      );
    },
    hasToBeSliced() {
      return this.breadcrumbCharLength > 59 && this.routeHistory.length > 3;
    },
    dynamicRoutes() {
      if (this.hasToBeSliced) {
        return this.routeHistory
          .slice(0, 2)
          .concat([
            {
              id: -1,
              label: '...',
            },
          ])
          .concat(this.routeHistory.slice(-1));
      }
      return this.routeHistory;
    },
    slicedRoutes() {
      if (this.hasToBeSliced) {
        return this.routeHistory.slice(2, -1);
      }
      return [];
    },
  },
  mounted() {
    this.route;
  },
};
</script>

<style lang="scss" scoped>
.case-path-navigator__icon-wrapper {
  display: flex;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background-color: $grey-2-mayday;
    color: $blue-mayday;
  }
}
.case-path-navigator__icon {
  cursor: pointer;
  color: $grey-8-mayday;
  font-size: 14px;
}

.case-path-navigator__item {
  font-size: 14px;
  color: $grey-8-mayday;
  border-radius: 4px;
  padding: 2px 4px;

  &:hover {
    background-color: $grey-2-mayday;
    cursor: pointer;
  }
}

.case-path-navigator__sliced-item {
  font-size: 12px;
  color: $grey-8-mayday;
  border-radius: 4px;
  padding: 2px 4px;

  &:hover {
    background-color: $grey-2-mayday;
    cursor: pointer;
  }
}

.case-path-navigator__item--last-step {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: text !important;
  pointer-events: none;
  color: $grey-5-mayday !important;
}

.case-path-navigator__separator {
  width: 14px;
  height: 14px;
}
</style>
